var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoAirplay = function SvgIcoAirplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 18,
    fill: "none",
    viewBox: "0 0 22 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M2 2v10h3a1 1 0 1 1 0 2H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h20a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1h-4a1 1 0 1 1 0-2h3V2zm8.293 10.293-4 4C5.663 16.923 6.109 18 7 18h8c.89 0 1.337-1.077.707-1.707l-4-4a1 1 0 0 0-1.414 0",
    clipRule: "evenodd"
  })));
};
export default SvgIcoAirplay;